import { Route, Routes } from 'react-router-dom';
import './App.css';
import About from './components/about/About';
import Home from './components/home/Home';
import Navbar from './components/navbar/Navbar';
import Thanks from './components/thanks/Thanks';

const App = () => (
  <div>
    <header>
      <Navbar />
    </header>
    <main className="h-screen">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/merci" element={<Thanks />} />
      </Routes>
    </main>
  </div>
);


export default App;
